module.exports = __webpack_public_path__ + "img/step4-03.f055c439.jpg";